/* eslint-disable ember/no-controller-access-in-routes */
import Route from '@ember/routing/route';

export default class ProfileimagesRoute extends Route {
  queryParams = {
    idType: {
      refreshModel: true,
    },
  };

  afterModel() {
    if (this.controller) {
      this.controller.reset();
    }
  }
}
